/* eslint-disable no-param-reassign */
const createPaymentWindow = (): Window | null => {
	// Check if the user is on a mobile device
	const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

	if (isMobile) {
		// For mobile devices, open a new tab instead of a new window
		const safariWindow = window.open('', '_blank');
		return safariWindow;
	}
	// For desktop devices, open a new window with specified dimensions
	const safariWindow = window.open('', 'win', `width=800,height=400,screenX=200,screenY=200`);
	return safariWindow;
};

const openPaymentView = (windowRef: Window | null, htmlString: string): Promise<boolean> => {
	return new Promise(resolve => {
		try {
			const winUrl = URL.createObjectURL(new Blob([htmlString], { type: 'text/html' }));

			if (windowRef) {
				// 在 LINE WebView 或某些環境中，location.href 賦值可能會失敗
				let navigationSuccess = false;

				try {
					const originalHref = windowRef.location.href;
					windowRef.location.href = winUrl;
					navigationSuccess = true;
					console.log('Successfully set location.href');

					// 設置一個短暫的延遲來檢查跳轉是否成功
					setTimeout(() => {
						try {
							console.log('Checking navigation success...');

							// 檢查窗口是否還存在且可訪問
							if (windowRef.closed) {
								console.log('Window is closed, navigation failed');
								resolve(false);
								return;
							}

							const currentHref = windowRef.location.href;
							console.log('Current href:', currentHref);
							console.log('Original href:', originalHref);

							// 檢查 URL 是否真的改變了
							if (currentHref !== originalHref && currentHref.includes('blob:')) {
								console.log('Navigation successful');
								resolve(true);
							} else {
								console.log('Navigation failed - URL did not change properly');
								resolve(false);
							}
						} catch (error) {
							console.log(
								'Error checking navigation, but navigationSuccess was:',
								navigationSuccess,
								'Error:',
								error,
							);
							// 無法訪問窗口屬性，可能是跨域問題
							// 如果之前設置成功了，我們認為跳轉成功
							resolve(navigationSuccess);
						}
					}, 300);
				} catch (error) {
					// location.href 賦值直接失敗，通常發生在 LINE WebView 等受限環境
					console.warn('Failed to set window location:', error);
					resolve(false);
				}
			} else {
				console.log('windowRef is null, navigation failed');
				resolve(false);
			}
		} catch (error) {
			console.warn('Failed to create payment view:', error);
			resolve(false);
		}
	});
};

export { openPaymentView, createPaymentWindow };
